import loginboxVue from './index.vue';    
// 定义插件对象
const Login = {};
// vue的install方法，用于定义vue插件
Login.install = function (Vue, options) {
  const LoginBoxInstance = Vue.extend(loginboxVue);
  let currentLogin;
  const initInstances = () => {
    // 实例化vue实例
    currentLogin = new LoginBoxInstance();
    let msgBoxEl = currentLogin.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$login = {
    showLoginBox (options) {
      initInstances();
      // if ( options === undefined || options === null || options == {} ) {
      //   //为空
      // } else if (typeof options === 'object') {
      //   Object.assign(currentLogin, options);
      // }
      currentLogin.visible = true;
    }
  };
};
export default Login;


// WEBPACK FOOTER //
// ./src/components/common/login/index.js